import { ShippingOption } from '@medusajs/medusa'

import axios from '@/core/axios'

import {
    ListShippingMethodsByCartIdDto,
    ShippingOptionsRes,
} from '../dtos/shipping-options.dto'

export class CheckoutRepository {
    public async getAllDeliveryOptions(): Promise<ShippingOption[]> {
        const { data } =
            await axios.get<ShippingOptionsRes>('/shipping-options')
        return data.shipping_options
    }

    public async listShippingMethodsByCartId(
        dto: ListShippingMethodsByCartIdDto,
    ): Promise<ShippingOption[]> {
        const { data } = await axios.get<ShippingOptionsRes>(
            `/shipping-options/${dto.cart_id}`,
        )
        return data.shipping_options
    }

    public async getAllPaymentMethods() {}
}
